package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_04_26_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had just defeated the Mariliths and are looking down into a hole in the demolished building.  Tuesday and Caper decide against descending into the ominous hole. The other heroes descend into the hole using the ladder and find a damp, acrid cavern.  They find a room with a gas cloud over an acid bath.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Falorn returns to the surface to try to convince Caper and Tuesday to join but fails.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes in the subterranean cavern trigger a pressure plate trap which moves the gas cloud. The heroes double back and check the western path where they find and jump over a trip wire.  As they continue, the temperature is getting warmer.  Goram sees a structure to the north and nearby enemies speaking abyssal.  Dirk tries to sneak up on the 4 Hezrou but fails. When the first Hezrou approaches the heroes, his stench is very strong and it poisons Bigglesworth, the others are disgusted but power through without being poisoned. Dirk sends an urgent message to Tuesday, warning that the party is under attack. Tuesday tells Caper.")
    }
}
